import { Injectable } from '@angular/core';
import { Path } from '@shared-enums';
import { SideNavigationItem, SideNavigationSubcategory } from '@shared-models';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavigationService {
  //#region Properties

  /**
   * Currently selected item from the side navigation
   * that will be displayed inside a header.
   */
  public activeSubcategory$ = new BehaviorSubject<SideNavigationSubcategory>({
    active: true,
    parent: 'Navigation.Reservations',
    path: Path.AllReservations,
    title: 'Navigation.AllReservations',
  });

  //#endregion

  //#region Methods

  /**
   * Define and return side navigation items
   * containing category titles, icons, and subcategories.
   *
   * @returns SIdeNavigation[]
   */
  getSideNavigationItems(): SideNavigationItem[] {
    return [
      {
        category: 'Navigation.Reservations',
        icon: 'deck_chair',
        expanded: false,
        subcategories: this.generateSubcategories('Navigation.Reservations', [
          'AllReservations',
          'DailyReports',
        ]),
      },
      {
        category: 'Navigation.Warehouse',
        icon: 'storefront',
        expanded: false,
        subcategories: this.generateSubcategories('Navigation.Warehouse', [
          'AllWarehouses',
        ]),
      },
    ];
  }

  /**
   * Generate a list of side navigation subcategories
   * for their names given. Parent represents the
   * category containing all subcategories generated here.
   *
   * Each subcategory must be added to Path enum with exactly same value.
   * For example subcategory X is added, there must be Path.X entry.
   * Also, nn the translation files, generate Navigation.X entry as well.
   *
   *
   * @param subcategories string[]
   * @param parent: string;
   *
   * @returns SideNavigationSubcategory[]
   */
  private generateSubcategories(
    parent: string,
    subcategories: string[],
  ): SideNavigationSubcategory[] {
    return subcategories.map(subcategory => ({
      title: `Navigation.${subcategory}`,
      path: Path[subcategory as keyof typeof Path],
      active: false,
      parent,
    }));
  }

  //#endregion
}
